import { ChevronDown } from "lucide-react";
import { ResponsivePopover as Popover, ResponsivePopoverContent as PopoverContent, ResponsivePopoverTrigger as PopoverTrigger } from "./ui/responsive-popover";
import { Button } from "./ui/button";
import { Checkbox } from "./ui/checkbox";

// Fonctions métier d'une fiche (0 à n). Même motif Popover + Checkbox que AcquisitionChannelField.
// Seules les fonctions actives sont proposées ; une fonction déjà portée reste affichée même désactivée depuis.
export default function JobFunctionsField({ functions, value, onChange, disabled, testid = "job-functions" }) {
  const selected = value || [];
  const choices = functions.filter((f) => f.active || selected.includes(f.id));
  const toggle = (id) => onChange(selected.includes(id) ? selected.filter((f) => f !== id) : [...selected, id]);
  const label = (f) => f.label + (f.active ? "" : " (inactive)");
  const summary = selected.length === 0 ? "Aucune" : choices.filter((f) => selected.includes(f.id)).map(label).join(", ");

  if (functions.length === 0) {
    return <p className="text-xs text-slate-500" data-testid={`${testid}-empty`}>Aucune fonction métier n'est encore définie (page Organisation).</p>;
  }
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" disabled={disabled} className="w-full justify-between font-normal" data-testid={`select-${testid}`}>
          <span className="truncate text-left text-slate-700">{summary}</span>
          <ChevronDown size={14} className="ml-2 text-slate-400 flex-shrink-0" />
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-72 p-2">
        <div className="space-y-0.5 max-h-64 overflow-y-auto scrollbar-thin">
          {choices.map((f) => (
            <label key={f.id} className="flex items-center gap-2.5 py-1.5 px-1 rounded hover:bg-slate-50 cursor-pointer" data-testid={`toggle-${testid}-${f.code}`}>
              <Checkbox checked={selected.includes(f.id)} onCheckedChange={() => toggle(f.id)} />
              <span className="text-sm text-slate-700">{label(f)}</span>
            </label>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
